module.exports = __webpack_public_path__ + "static/media/technical-support.77ddf299.svg";